import { excludeAbortError } from '@app/errors/AbortError'

import { createSelector } from '@app/utils/createSelector'
import { mergeV2Entity } from '@app/utils/mergeV2Entity'

import type { ApiDirectAnnouncement } from '@app/packages/api/v2/types/entities'

import { createReduxSlice } from '@app/store/redux_slice'

const directAnnouncementsSlice = createReduxSlice<{ [key: string]: ApiDirectAnnouncement }>('direct_announcements')

const directAnnouncementsMetaSlice = createReduxSlice<{ [key: string]: Meta }>('direct_announcements_meta')

export const mergeDirectAnnouncementSlice = (announcement: ApiDirectAnnouncement) =>
  directAnnouncementsSlice.update(state => ({ ...state, [announcement.id]: mergeV2Entity(state?.[announcement.id], announcement) }))

export const startDirectAnnouncementLoadSlice = (id: string) =>
  directAnnouncementsMetaSlice.update(state => ({ ...state, [id]: { ...(state?.[id] ?? DEFAULT_META), loading: true, error: null } }))

export const finishDirectAnnouncementLoadSlice = (id: string) =>
  directAnnouncementsMetaSlice.update(state => ({ ...state, [id]: { ...(state?.[id] ?? DEFAULT_META), loading: false, error: null } }))

export const failDirectAnnouncementLoadSlice = (id: string, error: Error) =>
  directAnnouncementsMetaSlice.update(state => ({ ...state, [id]: { ...(state?.[id] ?? DEFAULT_META), loading: false, error: excludeAbortError(error) } }))

export const directAnnouncementsModelsSelector = createSelector([directAnnouncementsSlice.selector], models => models ?? {})

export const directAnnouncementMetaSelector = (state: unknown, id: string): Meta => directAnnouncementsMetaSlice.selector(state)?.[id] ?? DEFAULT_META

type Meta = {
  loading: boolean
  updating: boolean
  error: Error | null
}

const DEFAULT_META: Meta = {
  loading: false,
  updating: false,
  error: null,
}
